<template>
  <v-dialog v-model="navigationGuardianChangeDataModal.active" width="500" persistent>
    <v-card
      class="d-flex flex-column align-center justify-space-around"
      :class="$vuetify.breakpoint.xsOnly ? 'pa-6' : 'pa-10'"
    >
      <div
        class="fw500 text-center mb-6"
        style="white-space: pre-line"
        :class="$vuetify.breakpoint.xsOnly ? 'f20' : 'f24'"
      >
        {{
          localStorage.translations.pages.common.text.unsave_changes +
          '\n\n' +
          localStorage.translations.pages.common.text.unsave_pages
        }}
      </div>
      <v-card tile flat width="100%" class="d-flex justify-space-around align-center">
        <v-btn
          @click="onUnsaveChange()"
          class="text-none br15"
          dark
          color="#277faf"
          x-large
          outlined
        >
          {{ localStorage.mobile.pages && localStorage.mobile.pages.mob_modal.common.yes }}
        </v-btn>
        <v-btn @click="onCloseModal()" class="text-none br15" dark color="#277faf" x-large>
          {{ localStorage.mobile.pages && localStorage.mobile.pages.mob_modal.common.no }}
        </v-btn>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import router from '~/router'
import store from '~/store'
router.beforeResolve((to, from, next) => {
  // console.log('beforeResolve', { to, from, next })
  if (to.name !== 'SalesProjectCreateContinue') {
    if (store.getters['navigationGuardian/navigationGuardianActive'] && from.name !== null) {
      next(false)
      store.commit('navigationGuardian/setNavigationGuardianChangeDataModal', { active: true, to })
    } else {
      if (to.name !== from.name) {
        store.dispatch('navigationGuardian/offNavigationGuardianCheck')
      }
      next()
    }
  } else next()
})
export default {
  name: 'ModalSaveChange',
  components: {},
  data() {
    return {
      form_dirty: true,
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  computed: {
    ...mapState('navigationGuardian', [
      'navigationGuardianChangeData',
      'navigationGuardianChangeDataModal',
      'navigationGuardianCheckData',
    ]),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
  },
  // watch: {
  //   '$route.name'() {
  //     if (this.$route.query.step == 1) {
  //       this.onWorkClientProjectShow(this.$route.params.id)
  //     }
  //   },
  // },
  methods: {
    ...mapMutations('navigationGuardian', [
      'setNavigationGuardianChangeDataModal',
      'setNavigationGuardianChangeData',
      'setNavigationGuardianCheckData',
    ]),
    ...mapActions('navigationGuardian', ['offNavigationGuardianCheck']),
    // confirmLeave() {
    //   return window.confirm('Do you really want to leave? you have unsaved changes!')
    // },
    // confirmStayInDirtyForm() {
    //   return this.form_dirty && !this.confirmLeave()
    // },
    beforeWindowUnload(e) {
      if (this.navigationGuardianActive) {
        e.preventDefault()
        e.returnValue = ''
        // var confirmationMessage = ('\o/'(e || window.event).returnValue = confirmationMessage) //Gecko + IE
        // return confirmationMessage
      }
    },
    onCloseModal() {
      this.setNavigationGuardianChangeDataModal({ active: false, to: null })
    },
    onUnsaveChange() {
      let path = this.navigationGuardianChangeDataModal.to.path
      this.offNavigationGuardianCheck()
      this.$router.push({ path })
    },
  },
}
</script>
